module.exports = __webpack_public_path__ + "img/restore.f387c66b.svg";